module.exports = __webpack_public_path__ + "static/media/paywayapp-se.5e3009ae.png";